import { useMutation } from 'react-query'

// Services
import { CreateDocument } from 'services/api/Ai'

export default () => {
  const {
    mutate: createDocument,
    data: createDocumentData,
    error: createDocumentError,
    isLoading: isCreateDocumentLoading,
    isSuccess: isCreateDocumentSuccess,
    isError: isCreateDocumentError,
  } = useMutation(CreateDocument)

  return {
    createDocument,
    createDocumentData,
    createDocumentError,
    isCreateDocumentLoading,
    isCreateDocumentSuccess,
    isCreateDocumentError,
  }
}
